// extracted by mini-css-extract-plugin
export default {"ListTab":"ListTabs_ListTab__x75a7","option":"ListTabs_option__GpROx","selected":"ListTabs_selected__mpnh3","divider":"ListTabs_divider__14vPr"};